import { makeSx } from '@saas/lib/shared-utils'
import idsTheme, { defaultPalette } from '../../theme/idsTheme'

const theme = idsTheme()

export const sxs = makeSx({
    alertBoxContainer: {
        textAlign: 'justify',
        width: '100%',
    },
    appBar: {
        backgroundColor: defaultPalette.white.main,
    },
    containerSwitchBaseLabelContent: {
        display: 'flex',
        alignItems: 'center',
        paddingTop: '15px',
    },
    labelSwitchContent: {
        fontWeight: 'bold',
        color: defaultPalette.darkGrey.main,
        marginLeft: '5px',
        fontSize: {
            xs: '0.75rem',
            sm: '1rem',
        },
    },
    gridItemsLabel: {
        display: 'inline-grid',
        [theme.breakpoints.down('sm')]: {
            minWidth: '190px',
        },
    },
    paper: {
        flexGrow: 1,
        padding: theme.spacing(2),
        textAlign: 'center',
        color: defaultPalette.typography.main,
        borderRadius: '2px',
        [theme.breakpoints.down('sm')]: {
            margin: '0px',
        },
    },
    tabsLabel: {
        fontWeight: 'bold',
        color: defaultPalette.darkGrey.main,
    },
})
